let loader = {
    show: () => { },
    hide: () => { }
};

let requestCount = 0;

export const setLoader = (functions) => {
    loader = functions;
};

export const showLoader = () => {
    requestCount++;

    if (requestCount === 1) {
        loader.show();
    }
};

export const hideLoader = () => {
    if (requestCount > 0) {
        requestCount--;
    }

    if (requestCount === 0) {
        loader.hide();
    }
};